import { render, staticRenderFns } from "./RoleAddDialog.vue?vue&type=template&id=1a4bf5ce&scoped=true"
import script from "./RoleAddDialog.vue?vue&type=script&lang=js"
export * from "./RoleAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bf5ce",
  null
  
)

export default component.exports